import { useInfiniteQuery } from '@tanstack/react-query'

import { getListOfCustomer } from '../functions'

interface IProps {
  searchText: string
  sortType: string
  type: string
  selectedStatus: Array<number>
  subAgentId: string | number
  selectedSource?: Array<string>
  limit?: number
}

function useListOfCustomer({
  limit = 10,
  searchText,
  selectedSource,
  selectedStatus,
  sortType,
  subAgentId,
  type,
}: IProps) {
  return useInfiniteQuery(
    [
      `customers`,
      searchText,
      sortType,
      type,
      selectedStatus,
      subAgentId,
      selectedSource,
    ],
    ({ pageParam = 0 }) => {
      return getListOfCustomer(
        searchText,
        sortType,
        type,
        pageParam || 0,
        selectedStatus,
        subAgentId || '',
        selectedSource
      )
    },
    {
      getNextPageParam: (lastPage, pages) => {
        return lastPage?.customerCount >= limit
          ? lastPage?.nextOffset ?? false
          : undefined
      },
    }
  )
}

export { useListOfCustomer }
